import Pill from '@pelckmans/elementis/components/pill';
import { useTranslation } from 'react-i18next';
import { formatAssignmentToDate } from '../utils/formatDate';

const WITHIN_24_HOURS_IN_HOURS = 24;
const WITHIN_7_DAYS_IN_HOURS = 168;
const MS_IN_HOUR = 1000 * 60 * 60;

function getPillProminenceByDeadline(deadline: string): 'danger' | 'warning' | 'neutral' {
  const now = new Date();
  const diffMs = Math.abs(new Date(deadline).getTime() - now.getTime());
  const diffHours = diffMs / MS_IN_HOUR;

  if (diffHours <= WITHIN_24_HOURS_IN_HOURS) {
    return 'danger';
  } else if (diffHours <= WITHIN_7_DAYS_IN_HOURS) {
    return 'warning';
  }

  return 'neutral';
}

export function AssignmentDeadlinePill({ deadline }: { deadline: string }) {
  const { t } = useTranslation();

  return (
    <Pill data-testid="deadline-pill" prominence={getPillProminenceByDeadline(deadline)}>
      {t('SHARED_COMPONENTS.ASSIGNMENT_DEADLINE_PILL.LABEL', {
        date: formatAssignmentToDate(deadline),
      })}
    </Pill>
  );
}
